// config.js
import { getConfigByKey } from '@/api/dict';

const state = {
    mailAddress: null
};

const mutations = {
    SET_MAIL_ADDRESS(state, mailAddress) {
        state.mailAddress = mailAddress;
    }
};

const actions = {
    async fetchMailAddress({ commit }) {
        try {
            // 调用服务器接口获取 mailAddress
            getConfigByKey('cp.file.mail').then((res) => {
                commit('SET_MAIL_ADDRESS', res.msg);
            });
        } catch (error) {
            console.error('Failed to fetch mailAddress:', error);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
